// extracted by mini-css-extract-plugin
module.exports = {"tikTokEmbedWrapper":"TiktokEmbed_tikTokEmbedWrapper__O_rpK","iFrameContainerTiktok":"TiktokEmbed_iFrameContainerTiktok___jh7E"};